import Container from "@mui/material/Container";
import DataTable from "./DataTable";
import React from "react";
import CommonLayout from "../../Common/Layout";

const SubCategory = () => {
  const breadcrumbArr = [{ link: "#", displayName: "Sub Category", active: true }];

  return (
    <CommonLayout title="Sub Category" breadcrumbArr={breadcrumbArr}>
      <Container maxWidth="false" sx={{ mt: 0, mb: 4, mx: 0 }}>
        <DataTable />
      </Container>
    </CommonLayout>
  );
};

export default SubCategory;
